// Move-order feedback, in the style of Age of Empires II: four brackets
// converge on the point you clicked, shrink onto it and fade out.
// Purely visual — it reflects the order that was sent, it doesn't affect it.
const DURATION_MS = 650;
const START_RADIUS = 26;
const END_RADIUS = 7;
const ARM = 7;
// Squashed vertically so the marker reads as lying on the ground.
const FLATTEN = 0.62;
const RED = "220, 46, 38";

export const MOVE_MARKER_MS = DURATION_MS;

// A queued waypoint: a small dark cross on the grass, one per point still to be
// walked. Deliberately low contrast — a route is context you glance at, not
// something that should compete with the units for attention. Squashed by the
// same FLATTEN as the move marker so it reads as lying on the ground.
const WAYPOINT_ARM = 6;

export const drawWaypoint = (ctx, x, y) => {
  ctx.save();
  ctx.lineCap = "round";
  ctx.lineWidth = 2;
  ctx.strokeStyle = "rgba(16, 20, 12, 0.45)";
  ctx.beginPath();
  ctx.moveTo(x - WAYPOINT_ARM, y - WAYPOINT_ARM * FLATTEN);
  ctx.lineTo(x + WAYPOINT_ARM, y + WAYPOINT_ARM * FLATTEN);
  ctx.moveTo(x + WAYPOINT_ARM, y - WAYPOINT_ARM * FLATTEN);
  ctx.lineTo(x - WAYPOINT_ARM, y + WAYPOINT_ARM * FLATTEN);
  ctx.stroke();
  ctx.restore();
};

const bracket = (ctx, x, y, radius, cornerX, cornerY) => {
  const px = x + cornerX * radius;
  const py = y + cornerY * radius * FLATTEN;
  ctx.beginPath();
  ctx.moveTo(px - cornerX * ARM, py);
  ctx.lineTo(px, py);
  ctx.lineTo(px, py - cornerY * ARM * FLATTEN);
  ctx.stroke();
};

export const drawMoveMarker = (ctx, x, y, elapsedMs) => {
  const progress = elapsedMs / DURATION_MS;
  if (progress < 0 || progress > 1) {
    return;
  }
  // Brackets rush inward, then ease onto the point.
  const eased = 1 - Math.pow(1 - progress, 3);
  const radius = START_RADIUS + (END_RADIUS - START_RADIUS) * eased;
  const alpha = 1 - progress * progress;

  ctx.save();
  ctx.lineCap = "round";
  ctx.lineWidth = 2.5;
  ctx.strokeStyle = `rgba(${RED}, ${alpha})`;
  for (const [cornerX, cornerY] of [[-1, -1], [1, -1], [-1, 1], [1, 1]]) {
    bracket(ctx, x, y, radius, cornerX, cornerY);
  }

  // A ring that expands away as the brackets close in.
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = `rgba(${RED}, ${alpha * 0.5})`;
  ctx.beginPath();
  ctx.ellipse(
    x,
    y,
    END_RADIUS + eased * 16,
    (END_RADIUS + eased * 16) * FLATTEN,
    0,
    0,
    2 * Math.PI
  );
  ctx.stroke();
  ctx.restore();
};
